import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';

import { $httpRootApi, getCancelRequestSource, yieldFailureResponse, yieldSuccessResponse } from '@core/http-client';
import { disposalsInsightsActions } from '@redux/reducers/insights/disposals-insights/disposalsInsightsReducer';
import { disposalsInsightsSelectors } from '@redux/selectors/insights/insightsDisposals';
import {
  DisposalsInsightsState,
  GetDisposalsInsightsRequestPayload,
  GetLettingInsightsResponse,
} from '@redux/types/insights/disposals-insights/disposalsInsightsTypes';
import { showNotification } from '@shared/components/notification';
import { getDefaultError, getQueriesAsSearch } from '@shared/utils/common';

export function* getDisposalsInsightsSaga(action: PayloadAction<GetDisposalsInsightsRequestPayload>) {
  const source = getCancelRequestSource();

  yield put(disposalsInsightsActions.setListLoading(true));

  const { error, response }: GetLettingInsightsResponse = yield call(() =>
    $httpRootApi
      .get(`/disposals/statistics${getQueriesAsSearch(action.payload)}`, {
        cancelToken: source.token,
      })
      .then(yieldSuccessResponse)
      .catch(yieldFailureResponse)
  );

  if (response) {
    yield put(disposalsInsightsActions.getListSuccess(response.data));
  } else if (error) {
    const errorMessage = getDefaultError(error.response?.data?.message || error.message);

    // Set the societies invalid flag
    if (error.response?.status === 403) {
      yield put(disposalsInsightsActions.setListSocietiesInvalid(true));
    }

    // Show error notification
    showNotification(errorMessage, 'error');

    // Set the message / errors list
    yield put(disposalsInsightsActions.getListFailure(errorMessage));
  }

  const { loading }: DisposalsInsightsState = yield select(disposalsInsightsSelectors.getState);
  if (loading) {
    source.cancel();
  }
}
